/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionDetails } from '@material-ui/core';
import { Tabs, Tab } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';
import { OrangeButton } from 'components/Button';
import { sanlamBlue } from 'Material-UI/colors';

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
export const StyledDiv = styled.div`
  margin-top: 10px !important;
`;

export const StyledAccordion = styled(({ color, ...otherProps }) => (
  <Accordion {...otherProps} />
))`
  border-left: 5px solid ${(props) => props.color};
  border-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  margin-top: 20px !important;
  padding: 0 !important;
`;

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    font-size: 11px !important;
    font-weight: bold;
    padding: 8px 16px;
    text-align: start;
    justify-content: flex-start;
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    border-left: none;
  }
`;

export const StyledTabs = styled((props) => {
  return (
    <Tabs
      {...props}
      classes={{ indicator: 'indicator' }}
      TabIndicatorProps={{ children: <span /> }}
      variant="scrollable"
      scrollButtons="auto"
    />
  );
})`
  && {
    background-color: #fff;
  }
  && .indicator {
    bottom: 3px;
    display: flex;
    justify-content: center;
    background-color: transparent;
    height: 3px;
    > span {
      max-width: 170px;
      width: 100%;
      background-color: ${sanlamBlue};
      border-radius: 1.5px;
    }
  }
`;

export const StyledTab = styled(Tab)`
  && {
    width: 161px;
    color: #566684;
    font-size: 15px !important;
    font-weight: 400;
    line-height: 18px;
    text-transform: none;
    &:focus {
      color: ${sanlamBlue} !important;
      background-color: #fff !important;
      font-weight: 500;
    }
    &&.Mui-selected {
      color: ${sanlamBlue};
      font-weight: 500;
    }
  }
`;
